export default "__VITE_ASSET__gajdejGU__"